export { maaAmet, fixedEncodeURIComponent };

function maaAmet(escapedCUtxt) {
	//var url = "http://www.maaamet.ee/ky/FindKYbyT.asp?txtCU=";
	//var url = "https://xgis.maaamet.ee/ky/FindKYByT.asp?txtCU=";
	var url = "https://xgis.maaamet.ee/ky/";

	return window.open(url + decodeURIComponent(escapedCUtxt), '', 'width=480,height=480,top=100,left=100,scrollbars=1,directories=0,status=0,resizable=1');
}

function fixedEncodeURIComponent(str) {
	return encodeURIComponent(str).replace(/[!'()]/g, escape).replace(/\*/g, "%2A");
}